import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeUpdateApiKeyModal, fetchUpdateApiKey, selectCurrentApiKey, selectIsUpdateApiKeyModalOpen, selectOnUpdate, updateApiKeySchema } from "../../model"
import { useEffect } from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormInput } from "@/shared/ui/form-input"
import {
    SCOPE_FIELDS,
    ScopeFormValues,
    emptyScopeFormValues,
    formValuesToScopes,
    scopesToFormValues,
} from "../../model/scopes"

interface UpdateApiKeyFormValues extends ScopeFormValues {
    enabled: boolean
}

const initialState: UpdateApiKeyFormValues = {
    enabled: false,
    ...emptyScopeFormValues()
}

export const UpdateApiKeyModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsUpdateApiKeyModalOpen)
    const onUpdate = useAppSelector(selectOnUpdate)
    const apiKey = useAppSelector(selectCurrentApiKey)

    const {
        handleSubmit,
        reset,
        register,
        formState: {
            isSubmitting
        }
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(updateApiKeySchema)
    })

    useEffect(() => {
        if (!isOpen) return

        // Форма стартует строго от фактических разрешений ключа: ни один
        // из трёх scope не может оказаться отмеченным сам по себе.
        reset({
            enabled: apiKey?.enabled,
            ...scopesToFormValues(apiKey?.scopes)
        })
    }, [apiKey, isOpen, reset])

    const handleClose = () => {
        dispatch(closeUpdateApiKeyModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchUpdateApiKey({
                enabled: data.enabled,
                scopes: formValuesToScopes(data, apiKey?.scopes)
            }))
                .unwrap()
                .then(() => {
                    notify.success('API-Ключ успешно изменен')
                    reset()
                    onUpdate?.()
                    handleClose()
                    res('')
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    Изменение <br />
                    API-Ключа <br />
                </div>
            )}
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    id="enabled"
                    label="Активен"
                    type="toggle"
                />
                <div className="flex flex-col gap-3">
                    <h3 className="text-base font-bold">Разрешения партнёрского API</h3>
                    {SCOPE_FIELDS.map((field) => (
                        <FormInput
                            key={field.scope}
                            register={register}
                            id={field.name}
                            label={field.label}
                            type="toggle"
                        />
                    ))}
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button" type="button">
                        Отменить
                    </button>
                    <button className="form_handle_button" disabled={isSubmitting} type="submit">
                        Сохранить
                    </button>
                </div>
            </form>
        </Modal>
    )
}
